import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/AuthContext";
import { PageLoader } from "@/components/ui/Loader";
import type { PermissionAction, PermissionResource } from "@/api/types";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <PageLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
}

export function RequirePermission({
  resource,
  action,
  children,
}: {
  resource: PermissionResource;
  action: PermissionAction;
  children: ReactNode;
}) {
  const { hasPermission } = useAuth();

  if (!hasPermission(resource, action)) {
    return (
      <div className="flex h-64 flex-col items-center justify-center gap-2 text-center">
        <p className="font-medium text-slate-700 dark:text-slate-200">Access restricted</p>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          You don't have permission to view this section.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
